/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphDataModel } from '../../models/graph-data-model';
import { GraphGrouping } from '../../models/graph-grouping';
import { PatientTargetStatus } from '../../models/patient-target-status';
import { ProgramGraphType } from '../../models/program-graph-type';
import { TargetType } from '../../models/target-type';

export interface GetProgramGraph$Params {
  patientID?: number;
  programID?: number;
  targetIDs?: Array<number>;
  startTime?: string;
  endTime?: string;
  programGraphType?: ProgramGraphType;
  targetTypeToFilter?: TargetType;
  targetStatusToFilter?: PatientTargetStatus;
  graphGrouping?: GraphGrouping;
  staffID?: number;
  includeTrendLine?: boolean;
  segmentTrendLineByPhase?: boolean;
  includeArchivedTargets?: boolean;
  includeClosedTargets?: boolean;
  includeOnHoldTargets?: boolean;
}

export function GetProgramGraph(http: HttpClient, rootUrl: string, params?: GetProgramGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetProgramGraph.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('programID', params.programID, {});
    rb.query('targetIDs', params.targetIDs, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('programGraphType', params.programGraphType, {});
    rb.query('targetTypeToFilter', params.targetTypeToFilter, {});
    rb.query('targetStatusToFilter', params.targetStatusToFilter, {});
    rb.query('graphGrouping', params.graphGrouping, {});
    rb.query('staffID', params.staffID, {});
    rb.query('includeTrendLine', params.includeTrendLine, {});
    rb.query('segmentTrendLineByPhase', params.segmentTrendLineByPhase, {});
    rb.query('includeArchivedTargets', params.includeArchivedTargets, {});
    rb.query('includeClosedTargets', params.includeClosedTargets, {});
    rb.query('includeOnHoldTargets', params.includeOnHoldTargets, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphDataModel>;
    })
  );
}

GetProgramGraph.PATH = '/api/Graph/GetProgramGraph';
